import QRCode from "qrcode";

function roundRect(ctx, x, y, width, height, radius, fill) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x + width, y + height, radius);
  ctx.arcTo(x, y + height, x, y + height, radius);
  ctx.closePath();
  ctx.fillStyle = fill;
  ctx.fill();
}

function drawText(ctx, value, x, y, size, color, weight = "normal") {
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `${weight} ${size}px "Microsoft YaHei", "PingFang SC", sans-serif`;
  ctx.fillStyle = color;
  ctx.fillText(value, x, y);
}

function wrapOrgName(ctx, name, maxWidth) {
  ctx.font = 'bold 30px "Microsoft YaHei", "PingFang SC", sans-serif';
  const lines = [""];
  for (const char of name) {
    const current = lines.length - 1;
    if (ctx.measureText(lines[current] + char).width > maxWidth && lines[current]) {
      if (lines.length === 2) {
        let second = lines[1];
        while (ctx.measureText(second + "…").width > maxWidth) second = second.slice(0, -1);
        lines[1] = second + "…";
        break;
      }
      lines.push(char);
    } else {
      lines[current] += char;
    }
  }
  return lines;
}

// 两个内勤端共用同一张注册分享图；二维码直接编码原注册链接。
export async function buildSalesmanRegistrationPoster(link, orgName, orgId) {
  if (!link || !orgName) throw new Error("机构信息或注册链接未生成");

  const canvas = document.createElement("canvas");
  canvas.width = 750;
  canvas.height = 1080;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("当前浏览器不支持生成分享图");

  const background = ctx.createLinearGradient(0, 0, 0, 1080);
  background.addColorStop(0, "#0874ca");
  background.addColorStop(0.48, "#47a4de");
  background.addColorStop(1, "#eaf7ff");
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, 750, 1080);
  ctx.fillStyle = "rgba(255,255,255,0.08)";
  ctx.beginPath(); ctx.arc(700, 50, 180, 0, Math.PI * 2); ctx.fill();
  ctx.beginPath(); ctx.arc(20, 300, 120, 0, Math.PI * 2); ctx.fill();

  drawText(ctx, "三高修复 · 健康重启", 375, 85, 41, "#ffffff", "bold");
  drawText(ctx, "业务员注册入口", 375, 150, 30, "#e8f5ff");

  ctx.save();
  ctx.shadowColor = "rgba(12,91,147,0.16)";
  ctx.shadowBlur = 28;
  ctx.shadowOffsetY = 12;
  roundRect(ctx, 50, 215, 650, 780, 32, "#ffffff");
  ctx.restore();

  drawText(ctx, "所属机构", 375, 273, 23, "#638098");
  const orgLines = wrapOrgName(ctx, orgName.trim(), 570);
  orgLines.forEach((line, index) => drawText(ctx, line, 375, 319 + index * 40, 30, "#163b5c", "bold"));
  drawText(ctx, `机构编号 ${orgId}`, 375, orgLines.length === 1 ? 361 : 397, 20, "#718da1");

  roundRect(ctx, 135, 425, 480, 480, 22, "#f0f7fc");
  const qr = document.createElement("canvas");
  const modules = QRCode.create(link, { errorCorrectionLevel: "M" }).modules.size;
  await QRCode.toCanvas(qr, link, {
    errorCorrectionLevel: "M",
    margin: 4,
    scale: Math.max(1, Math.floor(448 / (modules + 8))),
    color: { dark: "#102b40", light: "#ffffff" },
  });
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(qr, Math.floor((750 - qr.width) / 2), 425 + Math.floor((480 - qr.height) / 2));

  drawText(ctx, "微信扫码，注册并登录业务员端", 375, 942, 26, "#1677c8", "bold");
  drawText(ctx, "注册后自动关联上方机构", 375, 1030, 23, "#476d87");
  return canvas.toDataURL("image/png");
}
